import { useQuery } from '@apollo/client';
import { BakerUser } from '@bakerweb/models';
import { GET_BAKER_USER_BY_EMAIL } from '../graphql/queries/getBakerUserByEmail';
import { removeTypename } from '@bakerweb/utils';

export const useGetBakerUserByEmail = (email: string | undefined) => {
  const { loading, error, data } = useQuery<{ bakerUserByEmail: BakerUser }>(GET_BAKER_USER_BY_EMAIL, {
    variables: { email },
    skip: !email,
    fetchPolicy: 'cache-and-network'
  });

  const user = removeTypename(data?.bakerUserByEmail) as BakerUser | undefined;

  return { loading, error, user };
};
